




































import { Component, Vue, Prop } from "vue-property-decorator";
import { getImgUrl } from "../utils/dummy";
import Button from "./Button.vue";
import YesNoModal from "./YesNoModal.vue";
import { FlatTeam } from "../store/store.types";

@Component({
  name: "single-team",
  components: {
    Button,
    YesNoModal
  }
})
export default class SingleTeam extends Vue {
  @Prop() readonly team: FlatTeam;
  getImgUrl = getImgUrl;
  showModal: boolean = false;

  removeBatch(){
    this.$emit("deleteBatch");
  }
}
